<template>
  <div class="ex_milk_order">
    <!-- 兑换鲜奶 -->
    <title-bar-back :title="'确认订单'" @back="back">
      <div class="title_right"></div>
    </title-bar-back>
    <!-- <div @click="goResult">222222</div> -->
    <!-- 地址 -->
    <pur-address
      :address="address"
      :isAllow="toExchangeCardVoucher.isAllow"
      :addressConstant="toExchangeCardVoucher.addressConstant"
      @goAddressList="goAddressList"
    />
    <!-- 商品信息 -->
    <div class="product_con_det">
      <shop-header
        :switchOrderType="toExchangeCardVoucher.orderType"
        :storeName="toExchangeCardVoucher.storeName"
        @goExplain="goExplain"
      />
      <div
        v-for="(item, index2) in toExchangeCardVoucher.itemList"
        :key="index2"
      >
        <!-- 商品信息 -->
        <order-product-list
          :listIndex="index2"
          :pageShow="false"
          :item="item"
          class="pro_padd"
        />
        <!-- 赠品 -->
        <div
          v-if="item.giftList && item.giftList.length"
          class="free_product_list"
        >
          <free-product
            v-for="(item, index) in item.giftList"
            :key="index"
            :showLine="false"
            :freeProduct="item"
            :class="{ border_top1px: index === 0 }"
            class="free_pad"
          />
        </div>
      </div>
    </div>
    <!-- 确认兑换按钮 -->
    <div class="sure">
      <div
        class="sure_btn font12 font_weight500 colof line_height_17"
        @click="sureExchange"
      >
        确认兑换
      </div>
    </div>
    <!-- 鲜奶时间 -->
    <milk-date
      v-if="toExchangeCardVoucher.orderType === 1"
      @goChooseDate="goChooseDate"
      :item="toExchangeCardVoucher"
    />
  </div>
</template>
<script>
const TitleBarBack = () =>
  import("@/components/TitleBarBack").then(m => m.default || m);
import PurAddress from "../purchase/components/PurAddress";
import ShopHeader from "../purchase/components/ShopHeader";
import OrderProductList from "../list/components/OrderProductList";
import FreeProduct from "../../cart/components/FreeProduct";
const MilkDate = () =>
  import("../purchase/components/MilkDate").then(m => m.default || m);
export default {
  name: "ExchangeMilkOrder",
  components: {
    TitleBarBack,
    PurAddress,
    ShopHeader,
    OrderProductList,
    FreeProduct,
    MilkDate
  },
  data() {
    return {
      address: {}
    };
  },
  computed: {
    toExchangeCardVoucher() {
      return this.$store.getters.toExchangeCardVoucher;
    }
  },
  created() {
    this.getData();
  },
  methods: {
    back() {
      this.$router.back();
      localStorage.removeItem("mall-wap-exchange-card-choosedate");
      localStorage.removeItem("exchange-milk-pur-address");
    },
    getData() {
      // toExchangeCardVoucher
      const params = {
        id: this.$route.query.id,
        slug: this.slug,
        addressId: localStorage.getItem("exchange-milk-pur-address")
          ? JSON.parse(localStorage.getItem("exchange-milk-pur-address")).id
          : ""
      };
      this.$store
        .dispatch("order/toExchangeCardVoucher", { params })
        .then(() => {
          if (localStorage.getItem("exchange-milk-pur-address")) {
            this.address = JSON.parse(
              localStorage.getItem("exchange-milk-pur-address")
            );
          } else {
            this.address = JSON.parse(
              JSON.stringify(this.toExchangeCardVoucher.address)
            );
          }
        })
        .catch(() => {});
    },
    goAddressList() {
      this.$router.push({
        path: "/mine/addresslist",
        query: {
          previousPage: "exchangeMilkPur"
        }
      });
    },
    // 日期选择
    goChooseDate(deliveryPlanTime, startDate) {
      this.$router.push({
        path: "/order/choosedate",
        query: {
          deliveryPlanTime: this.toExchangeCardVoucher.currentAvailableTime,
          totalPeriods: this.toExchangeCardVoucher.totalPeriods,
          periodInterval: this.toExchangeCardVoucher.periodInterval,
          purPage: "exchangeCard",
          defaultPlanTime: startDate
        }
      });
    },
    // 发货说明
    goExplain() {
      // this.$router.push("/order/explaintime");
      this.$router.push("/order/milkexplaintime");
    },
    // 确认兑换 exchangeCardVoucher
    sureExchange() {
      // console.log(this.address);
      if (this.address === null) {
        this.$toast("请先选择收货地址");
        return;
      }
      this.$dialog
        .confirm({
          message: "您确定要兑换吗？",
          confirmButtonText: "确定",
          confirmButtonColor: "#DD9132"
        })
        .then(() => {
          this.$store
            .dispatch("order/exchangeCardVoucher", {
              params: {
                slug: this.slug,
                cardId: this.$route.query.id,
                addressId: this.address.id,
                deliveryPlanTime:
                  localStorage.getItem("mall-wap-exchange-card-choosedate") ||
                  this.toExchangeCardVoucher.deliveryPlanTime
              }
            })
            .then(res => {
              localStorage.removeItem("mall-wap-exchange-card-choosedate");
              this.$router.push({
                path: "/order/exchangesuccess",
                query: {
                  orderSn: res.orderSn
                }
              });
            })
            .catch(() => {});
        })
        .catch(() => {});
    }
  }
};
</script>
<style lang="less" scoped>
.ex_milk_order {
  // background: #fff;
  .title_right {
    width: 36px;
  }
  .product_con_det {
    border-radius: 8px;
    background: #fff;
    margin-top: 12px;
    .product_pad {
      padding-bottom: 9px;
      background: #fff;
    }
    .pad_mr {
      margin-top: 10px;
    }
  }
  .sure {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: flex-end;
    background: #fff;
    padding: 6px 12px;
    .sure_btn {
      background: linear-gradient(180deg, #e8caa1 0%, #bf9264 100%);
      box-shadow: -1px -1px 4px 0px rgba(255, 255, 255, 0.5);
      border-radius: 18px;
      padding: 10px 31px;
    }
  }
}
</style>
